import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import "../components/Chatbot.css";
import NriBuddyChatbot from '../pages/Chatbot';

const { FiPhone, FiMail, FiMapPin, FiMessageCircle } = FiIcons;

const Footer = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };

  return (
    <footer className="bg-gray-900 text-gray-300 relative border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">

          {/* Brand and Contact Information */}
          <div className="md:col-span-6 space-y-6">
            <div className="flex items-center space-x-2">
              <div className="flex items-center justify-center bg-white rounded-md px-4 py-1.5 h-14 shadow-sm w-auto">
                <img
                  src="/images/NRI_Logo.svg"
                  alt="NRI Local Buddy Logo"
                  className="h-full w-auto object-contain"
                />
              </div>
            </div>

            <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-md">
              Your trusted partner for managing local needs in India. We provide reliable,
              personalized services for property care, parental care, and travel assistance.
            </p>

            <div className="space-y-3 pt-2">
              <div className="flex items-center space-x-3 text-sm group">
                <SafeIcon icon={FiPhone} className="text-gray-400 group-hover:text-white transition-colors" />
                <a
                  href="https://wa.me/919618222498"
                  className="hover:text-white transition-colors duration-200"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +91 9618222498
                </a>
              </div>
              <div className="flex items-center space-x-3 text-sm group">
                <SafeIcon icon={FiMail} className="text-gray-400 group-hover:text-white transition-colors" />
                <a
                  href="mailto:hello@ay-technologies.com"
                  className="hover:text-white transition-colors duration-200"
                >
                  hello@ay-technologies.com
                </a>
              </div>
              <div className="flex items-start space-x-3 text-sm">
                <SafeIcon icon={FiMapPin} className="text-gray-400 mt-1 flex-shrink-0" />
                <span className="leading-relaxed">
                  112, Telkar Chambers, Tara Nagar, Chanda Nagar, Serilingampalle (M), Hyderabad, Telangana 500019
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links: Services */}
          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase mb-4">
              Services
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="/property-care" className="hover:text-white transition-colors duration-200 block py-0.5">
                  Property Care
                </a>
              </li>
              <li>
                <a href="/parental-care" className="hover:text-white transition-colors duration-200 block py-0.5">
                  Parental Care
                </a>
              </li>
              <li>
                <a href="/travel-services" className="hover:text-white transition-colors duration-200 block py-0.5">
                  Travel Services
                </a>
              </li>
              <li>
                <a href="/financial-advisory" className="hover:text-white transition-colors duration-200 block py-0.5">
                  Financial Advisory
                </a>
              </li>
              <li>
                <a href="/celebrate" className="hover:text-white transition-colors duration-200 block py-0.5">
                  Celebrate
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links: Support */}
          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase mb-4">
              Support
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="/help-center" className="hover:text-white transition-colors duration-200 block py-0.5">
                  24/7 Help Center
                </a>
              </li>
              <li>
                <a href="/faq" className="hover:text-white transition-colors duration-200 block py-0.5">
                  FAQs
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row md:justify-between items-center text-xs text-gray-500 space-y-4 md:space-y-0">
          <p className="order-2 md:order-1">
            &copy; {currentYear} NRI Local Buddy. All rights reserved.
          </p>
          <div className="order-1 md:order-2 flex space-x-4">
            <a href="/privacy-policy" className="hover:text-gray-300 transition-colors duration-200">
              Privacy Policy
            </a>
            <span className="text-gray-700">|</span>
            <a href="/terms-and-conditions" className="hover:text-gray-300 transition-colors duration-200">
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>

      {/* Floating Chatbot Toggle Button */}
      <div className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-50">
        <button
          onClick={toggleChatbot}
          className="bg-emerald-500 hover:bg-emerald-600 text-white p-3.5 sm:p-4 rounded-full shadow-xl transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-gray-900"
          aria-label="Open chat"
        >
          <SafeIcon icon={FiMessageCircle} className="text-2xl" />
        </button>
      </div>

      {/* Chatbot Modal */}
      {isChatbotOpen && (
        <NriBuddyChatbot onClose={toggleChatbot} />
      )}
    </footer>
  );
};

export default Footer;